import { historyStack } from "utils/hooks/useHistoryTracker.ts";
import { shouldBlockNavigation } from "utils/hooks/useBackButtonHandler.ts";
import { useRefValue } from "@shared/utils/hooks/misc.ts";
import { useHistory } from "react-router-dom";
import { useCallback } from "react";
import { DASHBOARD_PATH } from "common/constants.ts";

export const useHandleNavigateBack = () => {
  const historyRef = useRefValue(useHistory());

  const navigateBack = useCallback(() => {
    if (shouldBlockNavigation()) return;
    if (historyStack.length <= 1) {
      historyRef.current.push(DASHBOARD_PATH, {
        isBackButton: true,
      });
    } else {
      historyRef.current.push(historyStack[historyStack.length - 2], {
        isBackButton: true,
      });
    }
  }, []);

  return {
    navigateBack,
  };
};
